// Wraps console methods. The original is always called, with the same arguments.
// Known trade-off (Jam has it too): DevTools shows this wrapper as the log's source line.

import { formatConsoleArgs } from '../../shared/serialise.js';

const METHODS = {
  log: 'info',
  info: 'info',
  warn: 'warn',
  error: 'error',
  debug: 'debug',
  trace: 'debug',
};

export function installConsole(ctx, target = globalThis.console) {
  if (!target) return;

  const record = (method, level, args) => {
    if (ctx.busy) return;
    ctx.busy = true;
    try {
      const { title, args: serialised } = formatConsoleArgs(args, ctx.config.maxArgLength);
      let detail = { method, args: serialised };
      if (method === 'trace') detail.stack = new Error().stack;
      detail = ctx.sanitise('console', detail);
      if (!detail) return;
      ctx.push('console', level, title || `console.${method}()`, detail);
    } catch {
      // never let capture break the page's logging
    } finally {
      ctx.busy = false;
    }
  };

  for (const [method, level] of Object.entries(METHODS)) {
    const original = target[method];
    if (typeof original !== 'function') continue;
    const wrapped = function (...args) {
      record(method, level, args);
      return original.apply(this, args);
    };
    target[method] = wrapped;
  }

  const originalAssert = target.assert;
  if (typeof originalAssert === 'function') {
    target.assert = function (condition, ...args) {
      if (!condition) record('assert', 'error', ['Assertion failed:', ...args]);
      return originalAssert.call(this, condition, ...args);
    };
  }
}
